import { Button, styled } from "@mui/material";

const StyledDeleteButton = styled(Button)({
    color: "#D32F2F",
    fontSize: "14px",
    fontWeight: 400,
    fontFamily: "Arial",
    textTransform: "capitalize",
    lineHeight: "20px",
    borderRadius: "24px",
    borderColor: "#D32F2F",
    opacity: 1,
    minWidth: "122px",
    "&:hover": {
        borderColor: "#B71C1C",
        backgroundColor: "#FFEBEE",
    }
})

const WrappedDeleteButton = (props: any) => {
    return (
        <StyledDeleteButton variant="outlined" size="medium" {...props}>
            {props.children}
        </StyledDeleteButton>
    );
};

export default WrappedDeleteButton;
